import Router from 'vue-router'
import authorization from '@/utils/authorization'
import Home from '@/view/Home'
import Login from '@/view/Login'
import Adherents from './Adherents/routes'
import Correspondant from './Correspondant/routes'
import ConfirmAuthModal from '@/view/ConfirmAuthModal'
import Document from './Document/routes'
import Fiche from './Fiche/routes'
import Assistance from './Assistance/routes'
import Mutation from './Mutation/routes'
import MesCoordonnee from '@/view/Coordonnees/MesCoordonnees'
import Forgot from './Forgot/routes'
import Registration from './Registration/routes'
import ProtectionDonnees from './ProtectionDonnees/routes'

// il faut injecter le store car il y a une dependance circulaire
import { initUtils } from '@/utils/base'

const base = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_CORRESPONDANT,ROLE_PARTICIPANT)',
    },
  },
  {
    path: '/user/confirm',
    name: 'user/confirm',
    component: ConfirmAuthModal,
    meta: {
      auth: 'hasRole(ROLE_PARTICIPANT)',
    },
  },

  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: 'permit',
    },
  },
  {
    path: '/mescoordonnees',
    name: '/mescoordonnees',
    component: MesCoordonnee,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT,ROLE_PARTICIPANT)',
    },
    props: true,
  },
]
const router = new Router({
  routes: base
    .concat(Adherents)
    .concat(Correspondant)
    .concat(Document)
    .concat(Fiche)
    .concat(Mutation)
    .concat(Assistance)
    .concat(Forgot)
    .concat(Registration)
    .concat(ProtectionDonnees),
})
router.beforeEach((to, from, next) => {
  if (router.app && router.app.loading === false) {
    document.title = to.meta.breadcrumb
      ? router.app.$t(to.meta.breadcrumb().slice(-1).pop().code)
      : 'Extraciem'
  }

  initUtils(router.app)
  authorization(to, from, next)
})

export default router
